<template>
  <div class="chat-container w-100 position-relative bg-white">
    <top-navbar
      title="Orders History Detail"
      :url="'/' + getMerchant().code + '/r/order-history'" />
    <div class="w-100" style="height: 60px"></div>
    <div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <ErrorMessage v-if="error != ''" :message="error" />
      <template v-else>
        <div
          class="mb-4 mt-3 container py-3 w-100 box-shadow-primary rounded-10">
          <div class="row">
            <div class="my-2 col-6">
              <p class="mb-0 body-2-2 font-regular text-12">
                {{ $t('hotel.concierge.invoice') }}:
              </p>
              <p class="mb-0 body-2-2 font-bold text-14">{{ data.invoice }}</p>
            </div>
            <div class="col-6 my-2">
              <p class="mb-0 body-2-2 font-regular text-12">
                {{ $t('hotel.concierge.status') }}:
              </p>
              <p
                class="body-3-3-2 mb-0 restaurant-status-transaction d-table"
                :class="`restaurant-status-${data.status}`">
                {{ data.statusText }}
              </p>
            </div>
            <div class="col-6 my-2">
              <p class="mb-0 body-2-2 font-regular text-12">
                Order {{ $t('general.date') }}:
              </p>
              <p class="mb-0 body-2-2 font-bold">
                {{ formatDate(data.created_at) }}
              </p>
            </div>
            <div class="col-6 my-2">
              <p class="mb-0 body-2-2 font-regular text-12">Order Type:</p>
              <p class="mb-0 body-2-2 font-bold text-truncate">
                {{ data.orderType }}
              </p>
              <button
                @click="openTrackDelivery"
                v-if="
                  data.order_type === 'DELIVERY' && data.status === 'ONPROGRESS'
                "
                class="g-btn g-btn-primary g-btn-sm px-4">
                Track Your Order
              </button>
            </div>
          </div>
        </div>
        <div class="mb-4 container pb-4 w-100 box-shadow-primary rounded-10">
          <div class="row">
            <div class="col-12 mb-3">
              <p class="mb-0 body-1-4 text-18">
                {{ $t('restaurant.ordered-menu') }}
              </p>
            </div>
            <div class="col-12">
              <div
                class="d-flex align-items-top"
                v-for="(item_order, item_order_index) in data.tx_detail_list"
                :class="{
                  'pb-3 mb-3 border-b-form-dashed-2':
                    item_order_index + 1 < data.tx_detail_list.length,
                }">
                <div
                  class="position-relative radius-6 p-2 lh-1 border-green flex-shrink-0"
                  style="height: fit-content">
                  <p
                    class="text-14 mb-0 text-center font-lato w-100 lh-1 z-index-1026">
                    {{ item_order.qty }}x
                  </p>
                  <div class="primary-overlay radius-6 z-index-1025"></div>
                </div>

                <div class="mx-3 flex-fill">
                  <p class="body-2-1 mb-0">
                    {{ item_order.product_full_name }}
                  </p>
                  <p v-if="item_order.notes != null" class="mb-0 body-3-3-1">
                    Note : <b>{{ product.notes }}</b>
                  </p>
                  <p class="mb-0 text-14 font-lato">
                    {{ $formatCurrency(item_order.price_sell) }}
                  </p>
                </div>

                <div class="flex-shrink-0" style="width: 75px; height: 55px">
                  <img
                    :src="item_order.product_image"
                    class="img-fit radius-6" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4 pb-4 container w-100 box-shadow-primary rounded-10">
          <div class="row">
            <div class="col-12 mb-3">
              <p class="mb-0 body-1-4 text-18">
                {{ $t('restaurant.order-notes') }}
              </p>
            </div>
            <div class="col-12">
              <div
                class="p-2 w-100 rounded-6 border-form"
                style="min-height: 60px">
                {{ data.notes ? data.notes : '-' }}
              </div>
            </div>
          </div>
        </div>
        <div class="container pb-4 w-100">
          <div class="row">
            <div class="col-12 mb-3">
              <p class="mb-0 body-1-4 text-18">
                {{ $t('restaurant.price-detail') }}
              </p>
            </div>
            <div class="col-12">
              <div class="row mb-2 pb-1">
                <div class="col-6">
                  <p class="mb-0 body-2-2 font-semibold">
                    {{ $t('hotel.concierge.sub-total') }}
                  </p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 body-2-2 font-semibold">
                    {{ formatCurrency(data.total_amount) }}
                  </p>
                </div>
              </div>
              <div
                class="row mb-2 pb-1"
                v-if="Math.abs(data.total_discount) > 0">
                <div class="col-6">
                  <p class="mb-0 body-2-2 font-semibold text-green">
                    {{ $t('hotel.concierge.discount') }}
                  </p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 body-2-2 font-semibold text-green">
                    - {{ formatCurrency(Math.abs(data.total_discount)) }}
                  </p>
                </div>
              </div>
              <div class="row mb-2 pb-1">
                <div class="col-6">
                  <p class="mb-0 body-2-2 font-semibold">
                    {{ $t('hotel.concierge.tax-service') }}
                  </p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 body-2-2 font-semibold">
                    {{ formatCurrency(tax_service) }}
                  </p>
                </div>
              </div>
              <div class="border-top">
                <div class="row pt-2">
                  <div class="col-6">
                    <p class="mb-0 body-1-2 font-bold">
                      {{ $t('hotel.concierge.total') }}
                    </p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-1-2 font-bold">
                      {{ formatCurrency(data.total_payment) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- TRACK DELIVERY -->
        <DeliveryTrack ref="trackDelivery" :transaction-detail="data" />
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { get } from '@/services/index.js';
import moment from 'moment';
import { formatCurrency, formatDate } from '@/utils/index.js';
import DeliveryTrack from '../../components/general/DeliveryTrack.vue';

export default {
  components: {
    DeliveryTrack,
  },
  data() {
    return {
      data: {},
      is_load: true,
      error: '',
    };
  },
  computed: {
    tx_id() {
      return this.$route.params.tx_order_id;
    },
    status() {
      let data = {
        class_name: 'text-orange',
        text: this.$t('hotel.concierge.waiting'),
      };
      if (this.data.status == 'PENDING') {
        data.class_name = 'text-orange';
        data.text = this.$t('hotel.concierge.waiting');
      } else if (this.data.status == 'ONPROGRESS') {
        data.class_name = 'text-info';
        data.text = this.$t('hotel.concierge.on-progress');
      } else if (this.data.status == 'COMPLETE') {
        data.class_name = 'text-green';
        data.text = this.$t('hotel.concierge.complete');
      } else if (this.data.status == 'CANCELLED') {
        data.class_name = 'text-danger';
        data.text = this.$t('hotel.concierge.cancelled');
      } else {
        data.class_name = 'text-warning';
        data.text = this.data.status;
      }
      return data;
    },
    tax_service() {
      let tax_service =
        Number(this.data.total_taxes) + Number(this.data.total_service);
      return parseInt(tax_service);
    },
  },
  mounted() {
    this.getOrderDetail();
  },
  methods: {
    ...mapGetters(['getMerchant']),
    formatDate(date) {
      return moment(date).format('hh:mm, DD MMM YYYY');
    },
    formatCurrency(price) {
      return formatCurrency(price);
    },
    getOrderDetail() {
      this.data = {};
      this.is_load = true;
      this.error = '';
      get(
        'CORE_RESTO',
        'v2/tx-history/' + this.tx_id,
        {
          merchant_id: this.getMerchant().id,
        },
        'restaurant_session'
      ).then((response) => {
        let res = response.data;
        if (res.success) this.data = this.parsingDetailData(res.data);
        else this.error = res.message;
        this.is_load = false;
      });
    },
    parsingDetailData(detailData) {
      let detail = this.$deepCopy(detailData);
      detail.statusText = this.$parsingRestaurantStatusText(detail.status);
      detail.orderType =
        detail.order_type === 'DINE_IN' ? 'Dine In' : 'Delivery';
      detail.tx_detail_list = detail.tx_detail_list.map((x) => {
        x.product_full_name =
          x.variant_id != null
            ? `${x.variant_name} - ${x.product_name}`
            : x.product_name;
        return x;
      });
      return detail;
    },
    openTrackDelivery() {
      const element = this.$refs.trackDelivery;
      if (element) element.togglePopup(true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/restaurant/OrderHistoryDetail.vue